import { render, staticRenderFns } from "./MsgCenter.vue?vue&type=template&id=52707358&scoped=true&"
import script from "./MsgCenter.vue?vue&type=script&lang=js&"
export * from "./MsgCenter.vue?vue&type=script&lang=js&"
import style0 from "./MsgCenter.vue?vue&type=style&index=0&id=52707358&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52707358",
  null
  
)

export default component.exports